import type { ProductSource } from "../../shared/types";

export function SourceReview({ source, onReset, onAnalyze, busy }: { source: ProductSource; onReset: () => void; onAnalyze: () => void; busy: boolean }) {
  return (
    <section className="panel">
      <div className="section-heading between">
        <div className="heading-group"><span className="step-number">2</span><div><p className="eyebrow">資料確認</p><h2>系統擷取到這些資訊</h2></div></div>
        <button className="text-button" onClick={onReset}>重新輸入</button>
      </div>
      <div className="score-row">
        <div className="score-ring" style={{ "--score": `${source.extractionScore * 3.6}deg` } as React.CSSProperties}><span>{source.extractionScore}</span></div>
        <div><strong>資料完整度</strong><p className="muted">分數越高，越適合直接進行策略分析。</p></div>
      </div>
      {source.warnings.map((warning) => <p className="notice" key={warning}>{warning}</p>)}
      <dl className="source-meta">
        <div><dt>名稱</dt><dd>{source.title || "未辨識"}</dd></div>
        <div><dt>來源</dt><dd>{source.sourceUrl || "手動輸入"}</dd></div>
        <div><dt>有效區塊</dt><dd>{source.blocks.length} 個</dd></div>
      </dl>
      <details><summary>查看整理後文字</summary><pre className="source-preview">{source.content}</pre></details>
      <button className="primary-button" onClick={onAnalyze} disabled={busy}>{busy ? "正在提煉策略…" : "開始策略分析"}</button>
    </section>
  );
}
